
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Argenteuil dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Argenteuil certifiée Google Partner, soutient les entreprises argenteuillaises pour gagner en visibilité en ligne et développer leur clientèle.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Argenteuil dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Argenteuil certifiée Google Partner, soutient les entreprises argenteuillaises pour gagner en visibilité en ligne et développer leur clientèle.",
        },
      ],
    };
  },
};
